import { Lote } from "src/app/models/Lote.model";

// Estado global de registro
export interface FirmaFormState {
  lote: Lote | null;
  currentStep: number; // Para saber en qué paso estamos
  isComplete: boolean; // Indica si el formulario está totalmente completado
  lote_certificado: Array<any>;
}

// Estado inicial por defecto
export const initialRegistrationState: FirmaFormState = {
  lote: null,
  currentStep: 1,
  isComplete: false,
  lote_certificado: []
};